import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ChecklistEditor } from './checklists/ChecklistEditor';
import { ChecklistOverview } from './checklists/ChecklistOverview';
import { Card, CardHeader } from 'reactstrap';
import { propertyChecklistQueryOptions } from './checklists/checklistQueries';


export function TabPropertyChecklistEditor({
    propertyId,
    propertyChecklistId,
}) {
    // When we land on this tab and the property doesn't define a property checklist for this id,
    // we ask the user to confirm creating it.
    const {
        data,
        isLoading,
        isError,
        isSuccess,
        isFetched,
    } = useQuery(propertyChecklistQueryOptions(propertyId, propertyChecklistId));
    const queryClient = useQueryClient();

    if (isLoading || !isFetched) {
        return (
            <p>Loading...</p>
        );
    }

    if (isError || !isSuccess) {
        return (
            <p>Something went wrong while retrieving this property checklist.</p>
        );
    }

    const onSave = (changes) => {
        queryClient.setQueryData([ 'checklists', {
            checklistId: propertyChecklistId,
        } ], (staleData) => ({
            ...staleData,
            json: changes.json,
        }));
    };

    return (
        <div
            style={ {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                boxSizing: 'border-box',
                gap: '1rem',
            } }
        >
            <Card style={ { flex: 7 } }>
                <CardHeader>
                    Additions to { data.name }
                </CardHeader>
                <ChecklistEditor
                    checklist={ data }
                    onSave={ onSave }
                />
            </Card>
            <div style={ { flex: 3 } }>
                <ChecklistOverview checklist={ data.pmschecklistglobal } />
            </div>
        </div>
    );
}
